import React from "react";
import {Collapse} from "antd";
import styles from './styles.module.less';

const {Panel} = Collapse;

type TQa = {
  qa?: {id:number;answer:string;question:string}[]
}

const Qa:React.FC<TQa> = ({qa}) => {
  return (
    <div className={styles.qa_wrapper}>
      {qa && (
        <>
          <h3 className={styles.title}>常见问题</h3>
          <Collapse bordered={false} onChange={() => {}} expandIconPosition="right">
            {qa.map((item,index) => {
              return (
                <Panel key={item.id} header={<div className={styles.item_title}>{index+1}、{item.question}</div>} >
                  <p className={styles.item_text} dangerouslySetInnerHTML={{__html:item.answer}} />
                </Panel>
              )
            })}
          </Collapse>
        </>
      )}
    </div>
  )
}
export default Qa;
